import script from "./SubmitConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./SubmitConfirmDialog.vue?vue&type=style&index=0&id=d7516f3c&scoped=true&lang=css"
import "./SubmitConfirmDialog.vue?vue&type=style&index=1&id=d7516f3c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7516f3c"]])

export default __exports__